import instructionImg1 from "../../../images/ins1.png";
import instructionImg2 from "../../../images/ins2.png";

const instructioncontentJeeMain = {
  en: `<img src="${instructionImg1}"  alt="Instructions" /></p><p><img src="${instructionImg2}"  alt="Instructions" /></p>`,
  hi: `<img src="${instructionImg1}"  alt="Instructions" /></p><p><img src="${instructionImg2}"  alt="Instructions" /></p>`,
};
export default instructioncontentJeeMain; 